// @todo this is a duplicate redux with Home/service/redux/cancelQuestion
// should find a way to reuse.
import * as loadingState from '@coconut/constants/loadingState';

export const types = {
  CHAT_CANCEL_QUESTION: 'CHAT_CANCEL_QUESTION',
  CHAT_CANCEL_QUESTION_SUCCESS: 'CHAT_CANCEL_QUESTION_SUCCESS',
  CHAT_CANCEL_QUESTION_FAILED: 'CHAT_CANCEL_QUESTION_FAILED',
};

export const chatCancelQuestion = (userID, QID, lang) => ({
  type: types.CHAT_CANCEL_QUESTION,
  payload: {
    userID,
    QID,
    lang,
  },
});

export const chatCancelQuestionSuccess = () => ({
  type: types.CHAT_CANCEL_QUESTION_SUCCESS,
});

export const chatCancelQuestionFailed = () => ({
  type: types.CHAT_CANCEL_QUESTION_FAILED,
});

const INIT_STATE = {
  loadingStatus: loadingState.EMPTY,
};

export default function (state = INIT_STATE, action) {
  switch (action.type) {
    case types.CHAT_CANCEL_QUESTION:
      return {
        ...state,
        loadingStatus: loadingState.LOADING,
      };
    case types.CHAT_CANCEL_QUESTION_SUCCESS:
      return {
        ...state,
        loadingStatus: loadingState.READY,
      };
    case types.CHAT_CANCEL_QUESTION_FAILED:
      return {
        ...state,
        loadingStatus: loadingState.ERROR,
      };
    default:
      return state;
  }
}

export const getLoadingStatus = (state) =>
  state.chat.cancelQuestion.loadingStatus;



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/redux/cancelQuestion.js